/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-plusplus */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-mixed-operators */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-use-before-define */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-empty */
/* eslint-disable no-param-reassign */
/* eslint-disable camelcase */
/* eslint-disable no-debugger */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-undef */
/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable max-len */
import React, {
    useEffect, useCallback, useState, useContext,
} from 'react';
// import ReactModal from 'react-modal';
import uuid from 'react-uuid';
import ReactModal from 'react-modal';
import moment from 'moment';
import { Link, useParams, useNavigate } from 'react-router-dom';
import DistributorDetails from './Components/DistributorDetails';
import './style.css';
import StatusProgressbar from './Components/StatusProgressbar';
import ProductCard from './Components/ProductCard';
import TradeSummary from './Components/OrderSummary/TradeSummary';
import AssignASE from './Components/AssignASE';
import DistributorComments from './Components/DistributorComments';
import ApproveRejectBlock from './Components/ApproveRejectBlock';
import ErrorBlock from './Components/ErrorBlock';
import { distributorService } from '../../service/distributor.service';
import ThreePlModal from './Components/3PLModal';
import EubSummary from './Components/OrderSummary/EubSummary';
import DirectOrderSummary from './Components/OrderSummary/DirectOrderSummary';
import HeaderContext from '../../Components/Context/HeaderContext';
import RevisedSummary from './Components/OrderSummary/RevisedSummary';
import ApprovedBlock from './Components/ApprovedBlock';
import PendingApprovalsSkeleton from '../../Components/Skeletons/Pending-approvals';
import OrderInfoToolTip from './Components/OrderInfoToolTip';
import CancelOrderModal from './Components/CancelOrderModal';
import { useToast } from '../../context/ToastContext';
import TransferHistory from './Components/TransferHistory/index';
// import AddressChangeModal from './Components/AddressChangeModal';

export default function ManageOrders() {
    const navigate = useNavigate();
    const { orderId, distributorId } = useParams();
    const [OrderDetails, setOrderDetails] = useState({});
    const [addressDropdown, setaddressDropdown] = useState({});
    const [ThreePlPopup, setThreePlPopup] = useState('');
    const [ErrorBox, setErrorBox] = useState('');
    const [YesUpdate, setYesUpdate] = useState(false);
    const [distributorDetails, setdistributorDetails] = useState({});
    const [comment, setcomment] = useState('');
    const [ApproveStatus, setApproveStatus] = useState('');
    const [updated, setUpdated] = useState(false);
    const [ThreelPl, setThreelPl] = useState([]);
    const [GroupCategoryValue, setGroupCategoryValue] = useState('');
    const [validationResult, setValidationResult] = useState(null);
    const [validationSuccess, setValidationSuccess] = useState(false);
    const [UserRole, setUserRole] = useState('');
    const [hoverId, sethoverId] = useState(false);
    const [cancelPopup, setCancelPopup] = useState(false);
    const [euNameEdit, setEuNameEdit] = useState(false);
    const [euNameValue, setEuNameValue] = useState('');
    const [euNameSaving, setEuNameSaving] = useState(false);
    const [euNameError, setEuNameError] = useState('');
    const [transferUser, setTransferUser] = useState([]);
    const privilages = ['regional_sales_manager'];
    const location = useNavigate();
    const {
        isPopup,
        setisPopup,
        ErrorMessage,
        SetErrorMessage,
        SuccessMessage,
        SetSuccessMessage,
        colorValue,
        setcolorValue,
        HardRefresh,
        setHardRefresh,
        collapsed,
    } = useContext(HeaderContext);
    const [loading, setloading] = useState(true);
    const { showToast } = useToast();
    const [threeDotsLoader, setThreeDotsLoader] = useState(false);
    const handleshipbilladdress = (addressList) => {
        // let addressList = await distributorService.Getaddress()
        // console.log(addressList.data.data.data,"kkkkkkkk111")
        const shipping_address = [];
        const billing_address = [];
        if (addressList.length > 0) {
            addressList.map((item, i) => {
                const unique_id = uuid();

                if (item.SITE_USE_CODE === 'BILL_TO') {
                    item.unique_id = `${unique_id}-${i}`;
                    billing_address.push(item);
                } else {
                    item.unique_id = `${unique_id}-${i}`;
                    shipping_address.push(item);
                }
            });
        }
        setaddressDropdown({
            shipping_address,
            billing_address,
        });
        return {
            shipping_address, billing_address,
        };
    };
    const getAddresList = (id) => {
        distributorService.getDistributorDetailwithTransferUsers(id, orderId).then((res) => {
            if (!res.error && res.data.success_status) {
                setdistributorDetails(res?.data?.data);
                distributorService.getDistributorAddress(res?.data?.data.CUST_ACCOUNT_ID).then((res1) => {
                    if (!res1.error && res1.data.success_status) {
                        handleshipbilladdress(res1?.data?.data);
                    }
                });
            }
        });
    };
    const handleFetch = useCallback(
        async () => {
            const details = await distributorService.ViewOrderDetails(orderId, distributorId);
            if (!details.error && details.data.success_status) {
                getAddresList(details?.data?.data?.distributor_id);
                setOrderDetails(details.data.data);
                get3pl();
                const current = JSON.parse(localStorage.getItem('user')).profile.roles;
                if (current === 'copec') {
                    const validation = await distributorService.OrderValidation(orderId, distributorId);
                    if (!validation.error && validation.data.success_status) {
                        setValidationResult(validation.data.data);
                        const valid = Object.values(validation.data.data);
                        setValidationSuccess(false);
                        for (let index = 0; index < valid.length; index++) {
                            if (valid[index].result !== 'SUCCESS') {
                                setValidationSuccess(true);
                                break;
                            }
                        }
                    }
                }
                setUserRole(current);
                setloading(false);
            } else {
                handleErrorMessage(details?.data.message);
                setloading(false);
            }
        },
        [YesUpdate, orderId],
    );

    const [ItemLevel3pl, setItemLevel3pl] = useState({});
    useEffect(() => {
        handleFetch();
    }, [handleFetch]);
    const getItemCount = () => {
        let count = 0;
        OrderDetails?.items && Object.keys(OrderDetails.items).map((item) => {
            count += OrderDetails.items[item].length;
        });
        return count;
    };
    // useEffect(() => {
    //     console.log('re-render--->');
    // }, [OrderDetails]);
    const handleUpdateAddress = async (body, distributor_id, order_no) => {
        const response = await distributorService.UpdateAddress(body, distributor_id, order_no);
        if (!response.error && response.data.success_status) {
            handleSuccessMessage(response.data.message);
            setYesUpdate(!YesUpdate);
        } else {
            handleErrorMessage(response.data.message);
        }
        return response;
    };
    const handleErrorMessage = (message, key) => {
        SetErrorMessage(message || 'Something went wrong');
        setcolorValue(true);
        setTimeout(() => {
            SetErrorMessage('');
            setcolorValue(false);
        }, 2000);
    };
    const handleSuccessMessage = (message, key) => {
        SetSuccessMessage(message);
        setTimeout(() => {
            SetSuccessMessage('');
            setcolorValue(false);
            setYesUpdate(!YesUpdate);
        }, 2000);
    };
    const handleAddASE = async (body, key, three) => {
        setThreeDotsLoader(true);
        let payload = {};
        const currentRole = JSON.parse(localStorage.getItem('user')).profile.roles;
        if (key === 'ASE') {
            payload = {
                ASEs: body.ASEs,
            };
        } else if (key === 'Approval') {
            const orderDetailsCopy = { ...OrderDetails };
            let payloadKeys = {};
            payloadKeys = {
                approved_time: moment().unix(),
                approver: currentRole,
                note: comment,
            };
            payloadKeys.comment = comment;
            if (ApproveStatus === '0') {
                payloadKeys.status = 2;
            } else {
                payloadKeys.status = 1;
            }
            payloadKeys.created_at = moment().unix();
            payload = {
                approvals: payloadKeys,
            };
        } else if (key === 'threepl') {
            payload = body;
        } else if (key === 'transfer') {
            payload = {
                transfer_to_email: body[0]?.EMAIL,
                comment,
            };
            const res = await distributorService.transferOrder(payload, OrderDetails.distributor_id, OrderDetails.order_number);
            if (!res?.error && res?.data?.success_status) {
                setThreeDotsLoader(false);
                showToast(res?.data?.message);
                setThreePlPopup('');
                setItemLevel3pl({});
                setUpdated(false);
                setTransferUser([]);
                setcomment('');
                setApproveStatus('');
                handleFetch();
                return { success: true };
            }
            setThreeDotsLoader(false);
            showToast(res?.message || 'Error occured during update', '#ED1C24');
            // handleErrorMessage(res?.message || 'Error occured during update');
            return { success: false };
        }
        const response = await distributorService.OrderStatusUpdate(payload, OrderDetails.distributor_id, OrderDetails.order_number, three);
        if (!response.error && response.data.success_status) {
            setThreeDotsLoader(false);
            handleSuccessMessage(response.data.message);
            setThreePlPopup('');
            setItemLevel3pl({});
            setUpdated(false);
            return { success: true };
        }
        setThreeDotsLoader(false);
        handleErrorMessage(response?.data?.message || response?.message || 'Error occured during update');
        return { success: false };
    };
    const CheckIsApproved = () => {
        const currentRole = JSON.parse(localStorage.getItem('user')).profile.roles;
        const userCategories = JSON.parse(localStorage.getItem('user'))?.profile?.product_categories;
        let categories = [];
        for (let index = 0; index < OrderDetails?.ASEs?.length; index++) {
            const productCat = OrderDetails?.ASEs[index]?.PRODUCT_CATEGORIES === undefined ? OrderDetails?.ASEs[index]?.product_categories : OrderDetails?.ASEs[index]?.PRODUCT_CATEGORIES;
            if (productCat) {
                categories = [...categories, ...productCat];
            }
        }
        const categoriesList = [];
        const keys = Object.keys(OrderDetails?.items);
        keys.forEach((group) => {
            if (group === 'CONSUMABLES') {
                categoriesList.push(group);
            } else if (group.includes('EQUIPMENT')) {
                categoriesList.push('EQUIPMENT');
            } else if (group.includes('TRADING')) {
                categoriesList.push('EQUIPMENT');
            } else if (group.includes('MnR')) {
                categoriesList.push('MnR');
            } else categoriesList.push('OTHERS');
        });
        const unique = [...new Set(categories)];
        let aseValid = true;
        for (let elentIndex = 0; elentIndex < categoriesList.length; elentIndex++) {
            if (!unique.includes(categoriesList[elentIndex])) {
                aseValid = false;
                break;
            }
        }
        if (currentRole === 'copec') {
            return currentRole === OrderDetails.approvals.next_approval && OrderDetails.ASEs.length > 0 && aseValid;
        } if (currentRole === 'admin') {
            return true;
        }
        return currentRole.includes(OrderDetails.approvals.next_approval) && OrderDetails.ASEs.length > 0 && aseValid;
    };
    const get3pl = useCallback(
        async () => {
            if (ThreePlPopup === '') {
                const response = await distributorService.getNewthreepl();
                if (!response.error) {
                    setThreelPl(response.data.data);
                }
            }
        },
        [],
    );
    const handleRevisedPrice = async (body) => {
        const response = await distributorService.OrderrevisedPriceUpdate(body, OrderDetails.distributor_id, OrderDetails.order_number);
        if (!response.error && response.data.success_status) {
            setOrderDetails(response.data.data);
        }
    };

    const handleNotifyUser = async () => {
        const response = await distributorService.NotifyUser({ distributor_id: OrderDetails.distributor_id });
        if (!response.error && response.data.success_status) {
            handleSuccessMessage('Distributor has been notified!!');
        }
    };
    const handleDisable = () => {
        const arr = ['copec', 'regional_sales_manager'];
        const currentRole = JSON.parse(localStorage.getItem('user')).profile.roles;
        return !arr.includes(UserRole) || currentRole !== OrderDetails.approvals.next_approval;
    };
    const handleCancel = () => {
        setCancelPopup(!cancelPopup);
    };

    const orderCancel = async () => {
        setThreeDotsLoader(true);
        const res = await distributorService.OrderStatusUpdate({ status: 9 }, OrderDetails.distributor_id, OrderDetails.order_number);
        if (!res.error && res.data.success_status) {
            location('/cancelled-orders');
            setloading(false);
        } else {
            // console.log(res?.message?.response?.data?.message);
        }
        setCancelPopup(!cancelPopup);
    };

    const handleNavigate = () => {
        navigate(-1);
    };

    const handleEuNameSave = async () => {
        if (OrderDetails?.order_type === 'Trade EUB' && !euNameValue.trim()) {
            setEuNameError('End User Customer Name is mandatory');
            return;
        }
        setEuNameError('');
        setEuNameSaving(true);
        const res = await distributorService.OrderStatusUpdate({ eu_name: euNameValue.trim() }, OrderDetails.distributor_id, OrderDetails.order_number);
        setEuNameSaving(false);
        if (!res.error && res?.data?.success_status) {
            setOrderDetails((prev) => ({ ...prev, eu_name: euNameValue.trim() }));
            setEuNameEdit(false);
            showToast('End User Customer Name Updated Successfully');
        } else {
            showToast(res?.message || 'Failed to update End User Customer Name', '#ED1C24');
        }
    };

    return (
        <>
            {loading ? <PendingApprovalsSkeleton />
                : !loading && (
                    <div className="pb-6 pl-6 pr-[18px] main-screen relative">
                        <div className="flex items-center top-[94px] w-full pt-6 bg-[#FFFFFF] z-[99]">
                            <div onClick={() => handleNavigate()} data-testid="back-btn">
                                <img src="/images/Icon-feather-arrow-left-gray.svg" alt="icon" loading="lazy" decoding="async" />
                            </div>
                            <span className="text-lg font-normal text-[#555259] pl-3.5">
                                Order Details
                            </span>
                        </div>
                        <div className="flex">
                            <div className="w-[70%]">
                                <div className="flex -mx-1 mt-1 items-center">
                                    <div className="w-2/5 px-1">
                                        <div>
                                            <p className="text-sm font-semibold text-[#777777]">Order Number</p>
                                            <div className="flex items-center">
                                                <p className="text-xs24 font-semibold text-[#090406] pt-0.5" data-testid="order-number">
                                                    {OrderDetails.order_initial_number}
                                                </p>
                                                <p className="ml-6 p-1 bg-[#44445E] rounded text-xs3 font-normal text-[#FFFFFF]">
                                                    from
                                                    {' '}
                                                    {OrderDetails?.order_from}
                                                </p>
                                                {OrderDetails?.subscription_id !== null
                                                    && (
                                                        <p className="ml-2 p-1 bg-[#44445E] rounded text-xs3 font-normal text-[#FFFFFF]">
                                                            Bulk
                                                        </p>
                                                    )}
                                            </div>
                                        </div>
                                        <div className="flex space-x-5">
                                            <div className="pt-[22px]">
                                                <p className="text-xs font-semibold text-[#777777]">Order Created</p>
                                                <p className="text-lg font-normal text-[#090406]" data-testid="order-date">{moment.unix(OrderDetails.created_at).format('DD-MMM-YYYY HH:mm:ss')}</p>
                                            </div>
                                            {OrderDetails?.icd_number && (
                                                <div className="pt-[22px]">
                                                    <p className="text-xs font-semibold text-[#777777]">ICD Number</p>
                                                    <p className="text-lg font-normal text-[#090406] text-wrap break-all">{OrderDetails.icd_number || '-'}</p>
                                                </div>
                                            )}
                                        </div>
                                        {(!['Trade', 'Trade EUB'].includes(OrderDetails.order_type))
                                            && (
                                                <div className="pt-[22px] flex">
                                                    <p className="text-xl font-semibold text-[#777777]">Order Info.</p>
                                                    <span className="ml-1">
                                                        <button data-tooltip-target="tooltip-discountPrice" data-tooltip-placement="bottom" data-tooltip-trigger="click" type="button">
                                                            <img
                                                                src="/images/info_icon1.svg"
                                                                alt="icon"
                                                                width="15px"
                                                                height="15px"
                                                                className="cursor-pointer"
                                                                onMouseEnter={() => {
                                                                    setTimeout(() => {
                                                                        sethoverId(true);
                                                                    }, 1000);
                                                                }}
                                                                onMouseLeave={() => {
                                                                    setTimeout(() => {
                                                                        sethoverId(false);
                                                                    }, 2000);
                                                                }}
                                                            />
                                                        </button>
                                                        {hoverId && (
                                                            <OrderInfoToolTip OrderDetails={OrderDetails} />
                                                        )}
                                                    </span>
                                                </div>
                                            )}
                                    </div>
                                    <div className="w-3/5 px-1">
                                        {Object.values(OrderDetails).length > 0 && <DistributorDetails OrderDetails={OrderDetails} handleNotifyUser={handleNotifyUser} />}
                                    </div>
                                </div>
                                {Object.values(OrderDetails).length > 0 && <StatusProgressbar OrderDetails={OrderDetails} />}
                                <h5 className="text-xs6 font-semibold text-[#090406] pt-2">
                                    Products(
                                    {getItemCount()}
                                    )
                                </h5>
                                {OrderDetails.items && Object.values(OrderDetails?.items).map((item, i) => (
                                    <div key={Object.keys(OrderDetails.items)[i]} className="rounded-[12px] px-1 bg-[#F5F5FA] pt-3 mt-2.5 pb-3">
                                        <div className="px-3.5 flex justify-between">
                                            <div className="flex items-center">
                                                <p className="text-xs3 font-semibold text-[#090406]">
                                                    Products(
                                                    {item.length}
                                                    )
                                                </p>
                                                <p className="px-2 py-0.5 text-xs3 font-semibold text-[#FFFFFF] bg-[#44445E] rounded-[2px] ml-5">{Object.keys(OrderDetails.items)[i]}</p>
                                            </div>
                                            <ReactModal isOpen={ThreePlPopup !== ''}>
                                                <ThreePlModal
                                                    setThreePlPopup={setThreePlPopup}
                                                    ThreelPl={ThreelPl}
                                                    ThreePlPopup={ThreePlPopup}
                                                    handleUpdate3pl={handleAddASE}
                                                    GroupCategory={GroupCategoryValue}
                                                    ItemLevel3pl={ItemLevel3pl}
                                                    setItemLevel3pl={setItemLevel3pl}
                                                    threeplSelected={OrderDetails?.items[Object.keys(OrderDetails.items)[i]][0]['3pl']}
                                                />
                                            </ReactModal>
                                            <div className="flex items-center">
                                                <p className="text-xs font-normal text-[#777777]">3PL Location</p>
                                                <button
                                                    onClick={() => {
                                                        setGroupCategoryValue(Object.keys(OrderDetails.items)[i]);
                                                        setThreePlPopup('global');
                                                    }}
                                                    disabled={handleDisable()}
                                                    type="button"
                                                    className="border border-[#777777] min-w-[118px] h-7 rounded-md ml-2.5 bg-[#FFFFFF] text-xs6 font-normal text-[#303030] px-2.5"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#change3PL"
                                                >
                                                    <span className="flex">{OrderDetails?.items[Object.keys(OrderDetails.items)[i]][0]['3pl'].DESCRIPTION}</span>
                                                </button>
                                            </div>
                                        </div>
                                        {item.map((prod) => (
                                            <ProductCard
                                                key={prod.item_id}
                                                prod={prod}
                                                OrderDetails={OrderDetails}
                                                setOrderDetails={setOrderDetails}
                                                addressDropdown={addressDropdown}
                                                setThreePlPopup={setThreePlPopup}
                                                handleUpdateAddress={handleUpdateAddress}
                                                GroupCategory={GroupCategoryValue}
                                                setGroupCategoryValue={setGroupCategoryValue}
                                                groupIdx={i}
                                                handleRevisedPrice={handleRevisedPrice}
                                                UserRole={UserRole}
                                                setItemLevel3pl={setItemLevel3pl}
                                                handleFetch={handleFetch}
                                            />
                                        ))}
                                    </div>
                                ))}
                            </div>
                            <div className="w-[30%] ml-[26px]">
                                {Object.keys(OrderDetails).length > 0
                                    && (
                                        <div className="sticky top-[150px]">
                                            {['Trade', 'Trade EUB'].includes(OrderDetails.order_type) ? (
                                                OrderDetails.order_type === 'Trade' ? <TradeSummary OrderDetails={OrderDetails} /> : (
                                                    <>
                                                        {OrderDetails.summary.hasOwnProperty('revised_net_amount')
                                                            ? <RevisedSummary OrderDetails={OrderDetails} /> : <EubSummary OrderDetails={OrderDetails} />}
                                                    </>
                                                )) : <DirectOrderSummary OrderDetails={OrderDetails} />}
                                            {['Trade', 'Trade EUB'].includes(OrderDetails?.order_type) && (
                                                <div data-testid="manager-orders-eu-name-card" className="border border-[#CBC7C7] rounded-md bg-[#F5F5FA] overflow-hidden p-3 my-4">
                                                    <div className="flex items-center justify-between">
                                                        <p className="font-semibold text-base text-[#090406]">End User Customer Name</p>
                                                        {['sales_head', 'regional_sales_manager'].includes(UserRole) && !euNameEdit && (
                                                            <button
                                                                type="button"
                                                                className="text-sm font-bold text-[#555259] hover:text-[#090406]"
                                                                onClick={() => { setEuNameValue(OrderDetails?.eu_name || ''); setEuNameEdit(true); }}
                                                            >
                                                                Edit
                                                            </button>
                                                        )}
                                                    </div>
                                                    {euNameEdit ? (
                                                        <div>
                                                            <div className="relative pt-5 pb-2">
                                                                <input
                                                                    type="text"
                                                                    id="mo-eu-name"
                                                                    className={`h-12 w-full rounded-lg outline-0 border bg-[#FFFFFF] text-lg font-normal text-[#090406] px-3 ${euNameError ? 'border-[#ED1C24]' : 'border-[#B1B4B7]'}`}
                                                                    placeholder="Enter End User Customer Name"
                                                                    maxLength={240}
                                                                    value={euNameValue}
                                                                    onChange={(e) => { setEuNameValue(e.target.value); setEuNameError(''); }}
                                                                />
                                                                <label htmlFor="mo-eu-name" className="text-xs2 font-semibold text-[#808285] absolute top-3 left-3 px-1 bg-[#F5F5FA]">
                                                                    End User Customer Name
                                                                    {OrderDetails?.order_type === 'Trade EUB' && <span className="text-[#ED1C24]"> *</span>}
                                                                </label>
                                                            </div>
                                                            {euNameError && <p className="text-xs font-semibold text-[#ED1C24] -mt-1">{euNameError}</p>}
                                                            <div className="flex gap-2 pt-2 pb-3">
                                                                <button
                                                                    type="button"
                                                                    className="flex-1 h-[42px] rounded-lg border border-[#CBC7C7] py-3 text-xs6 font-semibold text-[#555259] bg-white"
                                                                    onClick={() => { setEuNameEdit(false); setEuNameError(''); }}
                                                                    disabled={euNameSaving}
                                                                >
                                                                    Cancel
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="flex-1 h-[42px] rounded-lg bg-[#555259] py-3 text-xs6 font-semibold text-[#FFFFFF] disabled:opacity-50"
                                                                    onClick={handleEuNameSave}
                                                                    disabled={euNameSaving || euNameValue.trim() === (OrderDetails?.eu_name || '').trim()}
                                                                >
                                                                    {euNameSaving ? 'Saving...' : 'Save'}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    ) : OrderDetails?.eu_name ? (
                                                        <div className="flex items-center mt-3 pr-3">
                                                            <span className="w-7 h-7 rounded-full bg-[#555259] text-white text-xs font-semibold flex items-center justify-center mr-2 flex-shrink-0">
                                                                {OrderDetails?.eu_name?.charAt(0).toUpperCase()}
                                                            </span>
                                                            <p data-testid="manager-orders-eu-name-value" className="font-normal text-m text-[#555259] truncate min-w-0 max-w-[calc(100%-3ch)]" title={OrderDetails?.eu_name}>{OrderDetails?.eu_name}</p>
                                                        </div>
                                                    ) : (
                                                        <p data-testid="manager-orders-eu-name-empty" className="font-normal text-sm text-[#555259] mt-2">-</p>
                                                    )}
                                                </div>
                                            )}
                                            <AssignASE
                                                OrderDetails={OrderDetails}
                                                setOrderDetails={setOrderDetails}
                                                distributorDetails={distributorDetails}
                                                handleAddASE={handleAddASE}
                                            />
                                            <DistributorComments OrderDetails={OrderDetails} />
                                            {OrderDetails?.transfer_history && OrderDetails?.transfer_history?.length > 0 && (
                                                <>
                                                    <TransferHistory OrderDetails={OrderDetails} />
                                                </>
                                            )}
                                            {CheckIsApproved() && (
                                                <ApproveRejectBlock
                                                    threeDotsLoader={threeDotsLoader}
                                                    setThreeDotsLoader={setThreeDotsLoader}
                                                    setcomment={setcomment}
                                                    setApproveStatus={setApproveStatus}
                                                    ApproveStatus={ApproveStatus}
                                                    handleApprove={handleAddASE}
                                                    handleCancel={handleCancel}
                                                    OrderDetails={OrderDetails}
                                                    setOrderDetails={setOrderDetails}
                                                    comment={comment}
                                                    updated={updated}
                                                    setUpdated={setUpdated}
                                                    validationSuccess={validationSuccess}
                                                    distributorDetails={distributorDetails}
                                                    setTransferUser={setTransferUser}
                                                    transferUser={transferUser}
                                                />
                                            )}
                                            {OrderDetails.approvals.next_approval === null
                                                && <ApprovedBlock OrderDetails={OrderDetails} />}
                                            {validationSuccess === true && validationResult !== null && <ErrorBlock validationResult={validationResult} />}
                                            {cancelPopup && <CancelOrderModal handleCancel={handleCancel} orderCancel={orderCancel} threeDotsLoader={threeDotsLoader} setThreeDotsLoader={setThreeDotsLoader} />}

                                        </div>
                                    )}
                            </div>
                        </div>
                    </div>
                )}

        </>
    );
}
